import React, { useRef } from "react";
import styles from '../styles/seveneasysteps.module.scss';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Card from "react-bootstrap/Card";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import CustomImage from "./CustomImage";

interface Props {
  data?: any;
}

const SeveneasySteps: React.FC<Props> = ({ data }) => {
  const sliderRef = useRef<Slider>(null);
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
  };

  return (
    <>
      <div id="seven-setpes" className={styles.seveneasySteps}>
        <Container>
          <Row className="text-center">
            <div >
              <h2 className={styles.mainTitle}>7 Easy Steps to Land in your Dream University</h2>
            </div>
          </Row>
          <Row id="seven-setp" className={styles.seveneasyStepsgr}>
            <Slider {...settings} ref={sliderRef}>
              <div className={styles.eventGuestSlider}>
                <div className={styles.sliderCardDiv}>
                  <Card className={styles.cardCust}>
                    <div className={styles.circle}>
                      1
                    </div>
                    <div className={styles.cardCustTop}>
                    </div>
                    <Card.Body className={styles.cardBody}>
                      <CustomImage src="/new-images/couselling-icon.svg" alt="cousellingIco.svg" width={105} height={60} />
                      <Card.Title className={styles.subTitle}>Counselling</Card.Title>
                      <Card.Text className={styles.textDate} >Plan your Academic and Career Goals.</Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className={styles.eventGuestSlider}>
                <div className={styles.sliderCardDiv}>
                  <Card className={styles.cardCust}>
                    <div className={styles.circle}>
                      2
                    </div>
                    <div className={styles.cardCustTop}>
                    </div>
                    <Card.Body className={styles.cardBody}>
                      <CustomImage src="/new-images/test-prep.svg" alt="testPrep.svg" width={105} height={60} />
                      <Card.Title className={styles.subTitle}>Test Preparation</Card.Title>
                      <Card.Text className={styles.textDate} >Appear for Standardized Tests</Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className={styles.eventGuestSlider}>
                <div className={styles.sliderCardDiv}>
                  <Card className={styles.cardCust}>
                    <div className={styles.circle}>
                      3
                    </div>
                    <div className={styles.cardCustTop}>
                    </div>
                    <Card.Body className={styles.cardBody}>
                      <CustomImage src="/new-images/course-icon.svg" alt="courseIco.svg" width={105} height={60} />
                      <Card.Title className={styles.subTitle}>Course, Country & University Selection</Card.Title>
                      <Card.Text className={styles.textDate} >Select the Country, the Program and the University</Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className={styles.eventGuestSlider}>
                <div className={styles.sliderCardDiv}>
                  <Card className={styles.cardCust}>
                    <div className={styles.circle}>
                      4
                    </div>
                    <div className={styles.cardCustTop}>
                    </div>
                    <Card.Body className={styles.cardBody}>
                      <CustomImage src="/new-images/applic-icon.svg" alt="applicIco.svg" width={105} height={60} />
                      <Card.Title className={styles.subTitle}>Application & Admission</Card.Title>
                      <Card.Text className={styles.textDate} >Apply to your Preferred Universities or Institutions</Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className={styles.eventGuestSlider}>
                <div className={styles.sliderCardDiv}>
                  <Card className={styles.cardCust}>
                    <div className={styles.circle}>
                      5
                    </div>
                    <div className={styles.cardCustTop}>
                    </div>
                    <Card.Body className={styles.cardBody}>
                      <CustomImage src="/new-images/edu-loan-icon.svg" alt="eduLoanIco.svg" width={105} height={60} />
                      <Card.Title className={styles.subTitle}>Education Loan & Financials</Card.Title>
                      <Card.Text className={styles.textDate} >Apply for Education Loan and Arrange Requisite Financials</Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className={styles.eventGuestSlider}>
                <div className={styles.sliderCardDiv}>
                  <Card className={styles.cardCust}>
                    <div className={styles.circle}>
                      6
                    </div>
                    <div className={styles.cardCustTop}>
                    </div>
                    <Card.Body className={styles.cardBody}>
                      <CustomImage src="/new-images/visa-icon.svg" alt="visaIco.svg" width={105} height={60} />
                      <Card.Title className={styles.subTitle}>Visa Processing</Card.Title>
                      <Card.Text className={styles.textDate} >Pay your Deposit, Accept your Offer and Apply for Visa</Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className={styles.eventGuestSlider}>
                <div className={styles.sliderCardDiv}>
                  <Card className={styles.cardCust}>
                    <div className={styles.circle}>
                      7
                    </div>
                    <div className={styles.cardCustTop}>
                    </div>
                    <Card.Body className={styles.cardBody}>
                      <CustomImage src="/new-images/addisuppico.svg" alt="addiSuppIco.svg" width={105} height={60} />
                      <Card.Title className={styles.subTitle}>Additional Support</Card.Title>
                      <Card.Text className={styles.textDate} >Attend Pre-Departure Session, Avail Forex & Insurance and Fly Abroad</Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </Slider>
            <div className={styles.arrowsClass}>
              <div onClick={() => sliderRef?.current?.slickPrev()}>
                <CustomImage src='/left_arrow.svg' height={10} width={6} alt={"left-arrow"} />
                <span>Previous Step</span>
              </div>
              <div onClick={() => sliderRef?.current?.slickNext()}>
                <span>Next Step</span>
                <CustomImage src='/right_arrow.svg' height={10} width={6} alt={"right-arrow"} />
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default SeveneasySteps;